export const initFileUploadData = () => ({
  serverFiles: [],
  addedFiles: [],
  deletedFiles: [],
})